<style lang="scss">
.m1_exam-reg-menu {
  border-bottom: 1px solid #cccccc;
  line-height: 0;
  text-align: center;
  ul {
    margin-bottom: 0;
    display: inline-block;
    li {
      float: left;
      margin-left: 40px;
      color: #666666;
      cursor: default;
      height: 40px;
      line-height: 32px;
      &:first-child {
        margin-left: 0;
      }
      @media screen and (max-width: 768px) {
        margin-left: 5px;
        font-size: 12px;
      }
    }
  }
  .active {
    border-bottom: 3px solid #009cfe;
    .arrow-up {
      width: 0;
      height: 0;
      margin: 0 auto;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
    }
  }
}
</style>
<template>
  <div class="m1_exam-reg-menu">
    <ul>
      <li :class="{active:menuIndex==6}" v-if="batchNum>1">
        选择批次
        <div class="arrow-up"></div>
      </li>
      <li :class="{active:menuIndex==1}" v-if="promiseState">
        考生承诺书
        <div class="arrow-up"></div>
      </li>
      <li :class="{active:menuIndex==2}">
        考生信息采集
        <div class="arrow-up"></div>
      </li>
      <li :class="{active:menuIndex==4}">
        确认提交信息
        <div class="arrow-up"></div>
      </li>
      <li :class="{active:menuIndex==5}" v-if="paySwitchStatus">
        报名完成
        <div class="arrow-up"></div>
      </li>
      <div class="clear"></div>
    </ul>
  </div>
</template>
 <script >
export default {
  props: {
    menuIndex: {
      default: "0"
    }
  },
  data: function() {
    return {
      batchNum: "",
      promiseState: "",
      paySwitchStatus: ""
    };
  },
  created: function() {
    if (this.$store.state.examRegInfo.examRegInfo) {
      this.examRegInfo = this.$store.state.examRegInfo.examRegInfo.pay_switch_status;
    } else {
      this.examRegInfo = false;
    }
    if (this.$store.state.examRegInfo.promiseState) {
      this.promiseState = this.$store.state.examRegInfo.promiseState;
    } else {
      this.promiseState = false;
    }
    if (this.$store.state.examInfo.batch) {
      this.batchNum = this.$store.state.examInfo.batch;
    } else {
      this.batchNum = false;
    }
  }
};
</script>